// extracted by mini-css-extract-plugin
export var dateTimeButton = "_av-1";
export var dateTimeButtonsContainer = "_av-6";
export var dateTimeInputContainer = "_av-7";
export var dateTimeWrapper = "_av-8";
export var disabledTile = "_av-0";
export var header = "_av-2";
export var line = "_av-3";
export var snoozeOption = "_av-4";
export var time = "_av-5";
export var todayTile = "_av-9";
export var wrapper = "_av-a";